import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7424dae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "function-help-video"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  role: "alert"
}
const _hoisted_4 = {
  class: "function-help-text",
  "aria-label": "使用说明"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "适合做什么？", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "使用方法", -1))
const _hoisted_7 = { "aria-hidden": "true" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "function-help-note" }, "请以当前页面实际显示的按钮、账号权限和处理结果为准。提交或保存后，查看页面反馈，并在对应列表、明细或设置中重新核对结果。", -1))
const _hoisted_11 = {
  class: "function-help-contact",
  "aria-label": "联系客服"
}
const _hoisted_12 = {
  key: 0,
  class: "function-help-contact-error"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "管理端客服", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "平台与分店管理端共用此客服入口。", -1))
const _hoisted_15 = {
  key: 0,
  class: "function-help-contact-options"
}
const _hoisted_16 = { class: "function-help-contact-qr" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手机微信扫码，直接进入客服对话", -1))
const _hoisted_18 = { class: "function-help-contact-desktop" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前电脑已登录微信？点击下方按钮尝试打开客服对话。", -1))
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "function-help-contact-hint" }, "是否直接唤起微信由微信客户端和浏览器决定；若出现扫码页，请扫描左侧二维码。", -1))
const _hoisted_22 = {
  class: "function-help-contact",
  "aria-label": "管理端客服设置"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "平台统一设置，保存后平台与分店管理端的“联系客服”使用同一入口。两项都留空可暂停入口。", -1))
const _hoisted_24 = { class: "function-help-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.title + ' · 帮助',
    footer: null,
    width: 860,
    destroyOnClose: true,
    onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createBlock(_component_a_tabs, {
            key: 0,
            activeKey: _ctx.activeTab,
            "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeTab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "video",
                tab: "帮助视频"
              }, {
                default: _withCtx(() => [
                  (_ctx.activeTab === 'video' && _ctx.safeUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(), _createElementBlock("video", {
                          key: _ctx.safeUrl,
                          src: _ctx.safeUrl,
                          controls: "",
                          playsinline: "",
                          preload: "metadata",
                          onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.failed = true)),
                          onLoadeddata: _cache[1] || (_cache[1] = ($event: any) => (_ctx.failed = false))
                        }, null, 40, _hoisted_2)),
                        (_ctx.failed)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "视频暂时无法播放，请检查网络或联系管理员核对视频地址。"))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.activeTab === 'video')
                      ? (_openBlock(), _createBlock(_component_a_empty, {
                          key: 1,
                          description: "暂无帮助视频，请查看使用说明。"
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "text",
                tab: "使用说明"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", null, _toDisplayString(_ctx.description || '查看本页信息，处理当前账号可使用的管理功能。'), 1),
                    _hoisted_6,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageSteps, (section, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: section.title,
                        class: "function-help-step"
                      }, [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(index + 1), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(section.title), 1),
                          (section.steps?.length === 1)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(section.steps?.[0]), 1))
                            : (_openBlock(), _createElementBlock("ol", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.steps, (step) => {
                                  return (_openBlock(), _createElementBlock("li", { key: step }, _toDisplayString(step), 1))
                                }), 128))
                              ]))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageNotes, (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        _createElementVNode("h3", null, _toDisplayString(section.title), 1),
                        _createElementVNode("p", null, _toDisplayString(section.content), 1)
                      ], 64))
                    }), 128)),
                    _hoisted_10
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "contact",
                tab: "联系客服"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_11, [
                    _createVNode(_component_a_spin, { spinning: _ctx.contactLoading }, {
                      default: _withCtx(() => [
                        (_ctx.contactError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_a_alert, {
                                type: "error",
                                message: _ctx.contactError,
                                "show-icon": ""
                              }, null, 8, ["message"]),
                              _createVNode(_component_a_button, {
                                loading: _ctx.contactLoading,
                                onClick: _ctx.loadContact
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("重新读取客服信息")
                                ]),
                                _: 1
                              }, 8, ["loading", "onClick"])
                            ]))
                          : (_ctx.contactLoaded)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_13,
                                _hoisted_14,
                                (_ctx.safeContactUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_qrcode_vue, {
                                          value: _ctx.safeContactUrl,
                                          width: 176,
                                          margin: 2,
                                          color: { dark: '#244568', light: '#ffffff' },
                                          type: "image/png",
                                          "aria-label": "微信扫码联系客服二维码"
                                        }, null, 8, ["value"]),
                                        _hoisted_17
                                      ]),
                                      _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createElementVNode("a", {
                                          class: "function-help-contact-link",
                                          href: _ctx.safeContactUrl,
                                          target: "_blank",
                                          rel: "noopener noreferrer"
                                        }, "在当前电脑打开客服", 8, _hoisted_20),
                                        _hoisted_21
                                      ])
                                    ]))
                                  : (_openBlock(), _createBlock(_component_a_empty, {
                                      key: 1,
                                      description: "平台暂未配置管理端客服，请稍后再试。"
                                    }))
                              ], 64))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["spinning"])
                  ])
                ]),
                _: 1
              }),
              (_ctx.canManage)
                ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                    key: "settings",
                    tab: "客服设置"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("section", _hoisted_22, [
                        _hoisted_23,
                        (_ctx.settingsError)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 0,
                              type: "error",
                              message: _ctx.settingsError,
                              "show-icon": "",
                              class: "function-help-alert"
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        (_ctx.settingsSaved)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 1,
                              type: "success",
                              message: "客服设置已保存，下方为服务器回读结果。",
                              "show-icon": "",
                              class: "function-help-alert"
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_spin, { spinning: _ctx.contactLoading }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form, { layout: "vertical" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { label: "企业微信客服链接" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.draftUrl,
                                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draftUrl) = $event)),
                                      placeholder: "https://work.weixin.qq.com/kfid/...",
                                      disabled: _ctx.settingsSaving
                                    }, null, 8, ["value", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, { label: "企业ID（CorpID）" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.draftCorpId,
                                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.draftCorpId) = $event)),
                                      placeholder: "ww 开头的企业ID",
                                      disabled: _ctx.settingsSaving
                                    }, null, 8, ["value", "disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_a_button, {
                                disabled: _ctx.contactLoading || _ctx.settingsSaving,
                                onClick: _ctx.loadContact
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("重新读取")
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]),
                              _createVNode(_component_a_button, {
                                type: "primary",
                                loading: _ctx.settingsSaving,
                                disabled: !_ctx.contactLoaded || _ctx.contactLoading || _ctx.settingsSaving,
                                onClick: _ctx.saveContact
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("保存客服设置")
                                ]),
                                _: 1
                              }, 8, ["loading", "disabled", "onClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["spinning"])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["activeKey"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}